var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM4.8 24C4.8 34.6039 13.3961 43.2 24 43.2C34.6039 43.2 43.2 34.6039 43.2 24C43.2 13.3961 34.6039 4.8 24 4.8C13.3961 4.8 4.8 13.3961 4.8 24Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1506 33.9906C44.3258 34.6037 45.7877 34.1514 46.2804 32.9209C47.5414 29.7716 48.1238 26.3817 47.9781 22.9743C47.798 18.7652 46.5132 14.6777 44.2527 11.1226C41.9923 7.56755 38.8359 4.67009 35.1007 2.72151C32.0769 1.14403 28.7601 0.233413 25.3732 0.0393103C24.0499 -0.0365298 23.0202 1.09546 23.0768 2.41974C23.1335 3.74401 24.2564 4.756 25.5774 4.8649C28.1203 5.07453 30.6042 5.78966 32.8806 6.97721C35.8687 8.53608 38.3938 10.854 40.2022 13.6981C42.0106 16.5422 43.0384 19.8122 43.1825 23.1794C43.2922 25.7446 42.8861 28.2973 41.9972 30.6889C41.5354 31.9314 41.9755 33.3776 43.1506 33.9906Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderMedium);
export default __webpack_public_path__ + "static/media/loader_medium.06f6220b0d08d2d5df5e718adce46e0a.svg";
export { ForwardRef as ReactComponent };